(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-elf-landing-v3"] && !Shopify.designMode) return;
  try {
    
let pendingV2Flight;
function captureV2CartFlight(options) {
  pendingV2Flight = undefined;
  const root = document.querySelector('.bb-elfv2');
  const target = root?.querySelector('[data-elfv2-cart]');
  const source = options.addToCartElem;
  if (!target || !source) return;
  const baseline = Number(target.querySelector('[data-elfv2-cart-count]')?.textContent);
  let image;
  try { image = document.querySelector(options.elemForAnimationSelector); } catch (error) {}
  const start = source.getBoundingClientRect();
  pendingV2Flight = {baseline, start, scrollX:window.scrollX || 0, scrollY:window.scrollY || 0, image: image?.tagName === 'IMG' ? image.cloneNode(false) : null, src: image?.currentSrc || image?.src};
}
function visibleV2CartBox() {
  const target = document.querySelector('.bb-elfv2')?.querySelector('[data-elfv2-cart]');
  if (!target) return {unavailable:true};
  if (document.querySelector('#AddToCartWidgetView .bottom-sheet-modal.visible')) return {covered:true};
  const box = target.getBoundingClientRect(), style = getComputedStyle(target);
  if (!target.getClientRects().length || style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0 || box.width <= 0 || box.height <= 0 || box.left < 0 || box.top < 0 || box.right > innerWidth || box.bottom > innerHeight) return {unavailable:true};
  if (target.checkVisibility && !target.checkVisibility({checkOpacity:true, checkVisibilityCSS:true})) return {unavailable:true};
  const hit = document.elementFromPoint?.(box.left + box.width / 2, box.top + box.height / 2);
  const modal = document.querySelector('#AddToCartWidgetView .bottom-sheet-modal.visible');
  if (modal || (hit && hit !== target && !target.contains(hit))) return {covered:true};
  return {box};
}
function waitForV2Cart() {
  return new Promise(resolve => {
    const deadline = Date.now() + 1200;
    let frames = 0;
    function check() {
      const result = visibleV2CartBox();
      if (result.unavailable || Date.now() >= deadline) return resolve(null);
      if (++frames >= 2 && result.box) return resolve(result.box);
      requestAnimationFrame(check);
    }
    requestAnimationFrame(check);
  });
}
function animateV2CartFlight(prepared, box) {
  return new Promise(resolve => {
    const clone = prepared.image, start = prepared.start, size = 32;
    if (!clone || start.width <= 0 || start.height <= 0) return resolve();
    ['id','srcset','sizes','class'].forEach(name => clone.removeAttribute(name));
    clone.src = prepared.src;
    clone.alt = '';
    clone.setAttribute('aria-hidden','true');
    clone.setAttribute('data-elfv2-cart-flight','');
    const fromX = start.left + start.width / 2 - size / 2;
    const fromY = start.top + start.height / 2 - size / 2;
    const dx = box.left + box.width / 2 - (fromX + size / 2);
    const dy = box.top + box.height / 2 - (fromY + size / 2);
    clone.style.cssText = `position:fixed;left:${fromX}px;top:${fromY}px;width:${size}px;height:${size}px;object-fit:cover;border-radius:6px;pointer-events:none;z-index:100000001;margin:0;max-width:none;`;
    let animation, done = false;
    const cleanup = () => {
      if (done) return;
      done = true;
      animation?.cancel();
      clone.remove();
      window.removeEventListener('scroll', cleanup, true);
      window.removeEventListener('resize', cleanup);
      resolve();
    };
    window.addEventListener('scroll',cleanup,{capture:true,passive:true,once:true});
    window.addEventListener('resize',cleanup,{once:true});
    document.body.append(clone);
    try {
      animation = clone.animate([
        {transform:'translate(0,0) scale(1)',opacity:1},
        {transform:`translate(${dx*.5}px,${dy*.5-35}px) scale(1.4)`,opacity:1,offset:.5},
        {transform:`translate(${dx}px,${dy}px) scale(.2)`,opacity:0}
      ],{duration:600,easing:'ease-in-out'});
      animation.finished.then(cleanup,cleanup);
    } catch (error) { cleanup(); }
  });
}
async function afterV2CartAdd(cart, openNativeCart) {
  const prepared = pendingV2Flight;
  pendingV2Flight = undefined;
  if (!prepared) { openNativeCart(); return; }
  if (!Number.isFinite(prepared.baseline) || !Number.isFinite(cart?.item_count) || cart.item_count <= prepared.baseline) return;
  try {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const box = await waitForV2Cart();
      if (box) await animateV2CartFlight(prepared,box);
    }
  } catch (error) {} finally { openNativeCart(); }
}
window.__bbElfV2Fly = captureV2CartFlight;
window.__bbElfV2AfterAdd = afterV2CartAdd;

function initCartEntry(root) {
  const trigger = root.querySelector('[data-elfv2-cart]');
  if (!trigger) return;
  const count = trigger.querySelector('[data-elfv2-cart-count]');
  let subscribed = false, opening = false, opened = false, fallbackTimer, focusTimer;
  function update(cart) {
    if (!Number.isFinite(cart?.item_count)) return;
    const value = String(cart.item_count);
    if (count.textContent !== value) count.textContent = value;
    trigger.setAttribute('aria-label', trigger.dataset.label + ', ' + value + ' ' + trigger.dataset.itemsLabel);
  }
  function attach() {
    if (!subscribed && typeof window.__bbFamilyCart?.subscribe === 'function') {
      subscribed = true;
      window.__bbFamilyCart.subscribe(update);
    }
  }
  async function refreshCount() {
    try {
      const response = await fetch(trigger.dataset.cartJson, {headers:{Accept:'application/json'}, cache:'no-store'});
      if (response.ok) update(await response.json());
    } catch (error) {}
  }
  function drawer() { return document.querySelector('#FDCartDrawer .cart-drawer'); }
  function visible() {
    const panel = drawer();
    if (!panel) return false;
    const box = panel.getBoundingClientRect();
    return box.width > 0 && box.left < innerWidth && box.right > 0 && getComputedStyle(panel.closest('#FDCartDrawer')).display !== 'none' && getComputedStyle(panel).visibility !== 'hidden';
  }
  function focusables() {
    return Array.from(drawer()?.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]') || []).filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  }
  function syncDrawer() {
    root.dataset.elfv2CartOpen = String(visible());
    if (!opening && !opened) return;
    const isOpen = visible();
    if (isOpen && !opened) {
      opening = false; opened = true;
      clearTimeout(fallbackTimer);
      trigger.setAttribute('aria-expanded','true');
      focusTimer = setTimeout(() => {
        const panel = drawer();
        if (visible() && panel && !panel.contains(document.activeElement)) {
          const close = panel.querySelector('[aria-label="Close cart"]');
          (close || focusables()[0])?.focus();
        }
      }, 250);
    } else if (!isOpen && opened) {
      opened = false;
      clearTimeout(focusTimer);
      trigger.setAttribute('aria-expanded','false');
      trigger.focus({preventScroll:true});
      refreshCount();
    }
  }
  root.addEventListener('click', event => {
    if (event.target.closest('[data-elfv2-cart]') !== trigger) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
      event.stopPropagation(); return;
    }
    if (!document.getElementById('FDCartDrawer')) {
      event.stopPropagation(); return;
    }
    event.preventDefault();
    opening = true;
    trigger.setAttribute('aria-controls','FDCartDrawer');
    trigger.setAttribute('aria-expanded','false');
    clearTimeout(fallbackTimer);
    fallbackTimer = setTimeout(() => {
      if (visible()) syncDrawer();
      else { opening = false; window.location.assign(trigger.href); }
    }, 1200);
  }, true);
  document.addEventListener('keydown', event => {
    if (!opened || !visible()) return;
    if (event.key === 'Escape') {
      const close = drawer()?.querySelector('[aria-label="Close cart"]');
      if (close) { event.preventDefault(); close.click(); }
    } else if (event.key === 'Tab') {
      const stops = focusables(), first = stops[0], last = stops[stops.length-1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !drawer().contains(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !drawer().contains(document.activeElement))) {
        event.preventDefault(); first.focus();
      }
    }
  });
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => record.target.nodeType === 1 && (record.target.closest?.('#FDCartDrawer') || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.id === 'FDCartDrawer' || node.querySelector?.('#FDCartDrawer')))))) return;
    queued = true; requestAnimationFrame(() => { queued = false; syncDrawer(); });
  }).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['style','class','hidden','aria-hidden']});
  document.addEventListener('transitionend', event => { if (event.target.closest?.('#FDCartDrawer')) syncDrawer(); });
  window.addEventListener('bb:cart-ready', attach);
  window.addEventListener('pageshow', refreshCount);
  window.addEventListener('focus', refreshCount);
  window.addEventListener('product:added', refreshCount);
  attach(); refreshCount(); syncDrawer();
}

(()=> {
  function initStoryVideos(root) {
    if (root.dataset.elfv3VideosReady) return;
    root.dataset.elfv3VideosReady = "true";
    const storyVideos = [...root.querySelectorAll('.elfv2-story video')];
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const states = new Map();
    const allowsAuto = () => !motion.matches && !connection?.saveData;
    const loadVideo = video => {
      const source = video.querySelector('source[data-src]');
      if (source && !source.hasAttribute('src')) {source.src = source.dataset.src;video.load();}
    };
    const pauseForEnvironment = video => {
      const state = states.get(video);
      if (!video.paused) {state.environmentPause = true;video.pause();}
    };
    const start = (video, manual = false) => {
      const state = states.get(video);
      if (!video.paused || state.pending || (!manual && (!state.visible || document.hidden || state.userPaused || state.blocked || !allowsAuto()))) return;
      state.pending = true;
      if (manual) {state.userPaused = false;state.blocked = false;}
      video.muted = true;video.defaultMuted = true;video.playsInline = true;
      loadVideo(video);
      let request;
      try { request = video.play(); } catch (error) { request = Promise.reject(error); }
      Promise.resolve(request).then(() => {
        if (document.hidden || (!manual && (!state.visible || state.userPaused || !allowsAuto()))) pauseForEnvironment(video);
      }).catch(error => {
        video.dataset.playbackError = error.name || 'PlaybackError';
        state.blocked = true;
        video.setAttribute('aria-label','Play: '+state.title);
      }).finally(() => {state.pending = false;});
    };
    storyVideos.forEach(video => {
      const state = {visible:false,userPaused:false,blocked:false,pending:false,environmentPause:false,title:video.closest('.elfv2-story').querySelector('h3').textContent};
      video.muted = true;video.defaultMuted = true;video.playsInline = true;
      video.setAttribute('muted','');video.setAttribute('playsinline','');
      states.set(video,state);
      const sync = () => {video.setAttribute('aria-label',(video.paused?'Play: ':'Pause: ')+state.title);video.setAttribute('aria-pressed',String(!video.paused));};
      const toggle = () => {
        if (!video.paused) {state.userPaused = true;video.pause();}
        else start(video,true);
      };
      video.addEventListener('click',toggle);
      video.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();toggle();}});
      video.addEventListener('play',()=>{state.userPaused=false;delete video.dataset.playbackError;sync();});
      video.addEventListener('pause',()=>{state.environmentPause=false;sync();});
      video.addEventListener('error',()=>{video.dataset.playbackError='MediaError'+(video.error?.code||'');video.closest('.elfv2-story').querySelector('.elfv2-video-error').hidden=false;});
      sync();
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries=>entries.forEach(entry=>{
        const video=entry.target,state=states.get(video);
        state.visible=entry.isIntersecting && entry.intersectionRatio>0.05 && (state.visible || entry.intersectionRatio>=0.35);
        if(state.visible)start(video);else pauseForEnvironment(video);
      }),{threshold:[0,0.05,0.35]});
      storyVideos.forEach(video=>observer.observe(video));
      root.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
    }
    // Retry blocked silent playback only during a normal interaction; respect preferences and deliberate pauses.
    root.addEventListener('click', event => {
      if (event.target.closest('.elfv2-story video') || !allowsAuto() || document.hidden) return;
      storyVideos.forEach(video => {const state=states.get(video);if(state.visible && state.blocked && !state.userPaused){state.blocked=false;start(video);}});
    });
    const refresh = () => storyVideos.forEach(video=>{if(document.hidden||!allowsAuto())pauseForEnvironment(video);else start(video);});
    document.addEventListener('visibilitychange',refresh);
    if(motion.addEventListener)motion.addEventListener('change',refresh);else motion.addListener?.(refresh);
    connection?.addEventListener?.('change',refresh);

  }
  function init(root) {
    if (!root) return;
    initStoryVideos(root);
    if (root.dataset.ready) return;
    initCartEntry(root);
    root.dataset.ready = 'true';

    // Chart mappings, values, conversions and presentation reused from live product-form.liquid.
    const fitProducts=[...root.querySelectorAll('.elfv2-fit-data')].map(e=>JSON.parse(e.textContent));
    let openFitDialog=null;
    function openFit(product,trigger,getSelected=()=>'',preview=null,chooser=false,focusTab=false){
      var original=product.original||'',title=product.title,kind=product.kind||'';
var text=(title+' '+kind).toLowerCase(), chart=null;
function C(name,columns,units,rows){return {name:name,columns:columns,units:units,rows:rows};}
var footie=C('Convertible Footie',['Weight','Height'],['lb','in'],[['Newborn','6–9','18–21'],['0–3 months','9–12','21–23'],['3–6 months','12–17','23–27'],['6–9 months','17–20','27–28'],['9–12 months','20–22','28–29'],['12–18 months','22–25','29–31'],['18–24 months','25–27','31–33'],['2/3T','27–32','33–36']]);
var kids=C('Kids Pajamas, Short Sets & Dresses',['Weight','Height'],['lb','in'],[['18–24 months','25–27','31–33'],['2T','27–30','33–35'],['3T','28–32','35–37'],['4T','33–36','37–40'],['5T','37–42','41–43'],['6Y','43–48','44–46'],['7/8Y','48–64','47–54'],['9/10Y','62–78','53–57'],['12/14Y','75–110','56–62']]);
var women=C("Women's Pajamas & Nightgowns",['Shirt length','Bust','Pant waist','Pant length'],['in','in','in','in'],[['XS','24.5','30–32','23–25','37'],['S','25.5','32–34','26–28','38'],['M','26','35–37','29–30','39'],['L','27','37–39','31–32','40'],['XL','28','38–42','33–35','41'],['XXL','29','42–46','35–38','42']]);
var men=C("Men's Pajamas",['Shirt length','Bust','Pant waist','Pant length'],['in','in','in','in'],[['XS','28.5','33–35','26–28','39'],['S','29','36–38','28–30','40'],['M','30','38–40','30–32','41'],['L','30.5','40–42','32–34','42'],['XL','31','42–44','34–36','43'],['XXL','31.5','45–47','37–39','44']]);
var girlUnder=C("Girls' Underwear",['Waistband','Length'],['in','in'],[['2/3T','16.5','4.5'],['4/5T','17.3','4.7'],['6/7Y','18.1','5.1'],['8/9Y','18.9','5.7']]);
var boyUnder=C("Boys' Underwear",['Waistband','Length'],['in','in'],[['2/3T','16.5','5.1'],['4/5T','17.3','5.9'],['6/7Y','18.9','6.3'],['8/9Y','20.5','6.5']]);
var womenUnder=C("Women's Underwear",['Waistband','Pant length'],['in','in'],[['S','26–28','8.75'],['M','29–30','9.25'],['L','31–32','9.75'],['XL','33–35','10'],['XXL','35–38','10.25']]);
var menUnder=C("Men's Underwear",['Waistband','Pant length'],['in','in'],[['S','28–30','10.25'],['M','30–32','10.5'],['L','32–34','10.75'],['XL','34–36','11'],['XXL','37–39','11.25']]);
var kidRobe=C('Kids Sherpa Robe',['Weight','Height'],['lb','in'],[['S/M','27–48','33–46'],['M/L','48–78','46–57']]);
var adultRobe=C('Adult Sherpa Robe',['Length','Waist','Sleeve'],['in','in','in'],[['S/M','38','20','64'],['M/L','39','22','67']]);
var sharedChart=/size_chart_df5dea8b-51de-466d-8968-36372e04a7e7/.test(original);
if(sharedChart||/convertible footie/.test(text)){
if(/underwear|boxer|brief|panties/.test(text)){if(/women/.test(text))chart=womenUnder;else if(/\bmen/.test(text))chart=menUnder;else if(/girl/.test(text))chart=girlUnder;else if(/boy/.test(text))chart=boyUnder;}
else if(/robe/.test(text))chart=/adult|women|\bmen/.test(text)?adultRobe:/kid|child/.test(text)?kidRobe:null;
else if(/convertible footie/.test(text))chart=footie;
else if(/women/.test(text)&&/pajama|nightgown/.test(text))chart=women;
else if(/\bmen/.test(text)&&/pajama/.test(text))chart=men;
else if(/kid|girl|boy|toddler/.test(text)&&/pajama|short set|dress/.test(text))chart=kids;
}
if(/[/]2_8[.]png/.test(original)){chart=C('Kids Pajamas, Short Sets & Dresses',['Weight','Height'],['lb','in'],[['18–24 months','25–27','31–33'],['2T','27–30','33–35'],['3T','30–33','35–37'],['4T','33–36','37–40'],['5T','37–42','41–43'],['6Y','43–48','44–46'],['7/8Y','48–64','47–53'],['9/10Y','64–78','53–57'],['12/14Y','78–110','57–62']]);}
if(/[/](8_1|9_1)[.]png/.test(original)){chart=C(/[/]8_1[.]png/.test(original)?"Girls' Underwear":"Boys' Underwear",['Weight','Height'],['lb','in'],[['2/3T','27–32','33–37'],['4/5T','33–42','37–43'],['6/7Y','42–56','44–50'],['8/9Y','57–70','51–55']]);}

if(/[/]men_pajama[.]png/.test(original)){chart=C("Men's Pajamas",men.columns,men.units,[['XXS','28','30–32','24–26','38']].concat(men.rows.map(function(r){return r[0]==='XXL'?['XXL','31.5','44–48','37–39','44']:r;})));}
if(/[/]women_pajama[.]png/.test(original)){chart=C("Women's Pajamas",women.columns,women.units,[['XXS','23.5','28–30','21–23','36'],['XS','24.5','30–32','23–25','37'],['S','25.5','32–34','26–28','38'],['M','26','35–37','28–30','39'],['L','27','37–39','30–32','40'],['XL','28','38–42','33–35','41'],['XXL','29','42–46','35–38','42']]);}
if(/[/]women_short_set[.]png/.test(original)||(sharedChart&&/women/.test(text)&&/short/.test(text))){chart=C("Women's Short Sets",['Shirt length','Bust','Waist','Pant length'],['in','in','in','in'],[['XXS','23.5','28–30','21–23','14'],['XS','24.5','30–32','23–25','14.5'],['S','25.5','32–34','26–28','15.5'],['M','26','35–37','28–30','16'],['L','27','37–39','30–32','16.5'],['XL','28','38–42','33–35','17'],['XXL','29','42–46','35–38','17.5']]);}
if(/[/]women_nightgown[.]png/.test(original)||(sharedChart&&/women/.test(text)&&/nightgown/.test(text))){chart=C("Women's Nightgowns",['Bust','Waist','Dress length'],['in','in','in'],[['XXS','28–30','14','32'],['XS','30–32','15','33'],['S','32–34','16','33.5'],['M','35–37','17','34'],['L','37–39','18.5','35'],['XL','38–42','19.5','35.5'],['XXL','42–46','20.5','36']]);}
if(/[/]women_s_underwear[.]png/.test(original)){chart=C("Women's Underwear",['Waist','Length'],['in','in'],[['XS','23–25','8.25'],['S','26–28','8.75'],['M','28–30','9.25'],['L','30–32','9.75'],['XL','33–35','10'],['XXL','35–38','10.25']]);}
if(/[/]men_s_underwear[.]png/.test(original)){chart=C("Men's Underwear",['Waist','Length'],['in','in'],[['XS','26–28','10'],['S','28–30','10.25'],['M','30–32','10.5'],['L','32–34','10.75'],['XL','34–36','11'],['XXL','37–40','11.25']]);}
if(/3_59325861-2a9a-4403-884b-07330f74a9b1/.test(original)){chart=/adult|women|\bmen/.test(text)?adultRobe:/kid|child/.test(text)?kidRobe:null;}
if(/1_7de43724-f010-4077-a976-399c8e2da41c/.test(original))chart=footie;
// The dedicated adult charts supply XXS omitted from the legacy combined chart.
if(sharedChart&&chart===men)chart=C(men.name,men.columns,men.units,[['XXS','28','30–32','24–26','38']].concat(men.rows));
if(sharedChart&&chart===women&&!/nightgown|short/.test(text))chart=C(women.name,women.columns,women.units,[['XXS','23.5','28–30','21–23','36']].concat(women.rows));
function normalize(s){return String(s||'').toLowerCase().replace(/[–—]/g,'-').replace(/months?|\s/g,'').replace(/^2xs$/,'xxs').replace(/^2xl$/,'xxl').replace(/(\d)t?[-/](\d)([ty])/g,'$1/$2$3');}
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
var options=product.options;
// A size printed as dimensions is already a product-specific measurement.
if(!chart&&options.length&&options.every(function(s){return /^\s*\d+(\.\d+)?\s*[x×]\s*\d+(\.\d+)?\s*(in|inch|inches|cm)\s*$/i.test(s);})){chart=C('Product Dimensions',['Width','Length'],[],options.map(function(s){var m=s.match(/([\d.]+)\s*[x×]\s*([\d.]+)\s*(in|inch|inches|cm)/i);return [s,m[1],m[2]];}));chart.units=[/cm/i.test(options[0])?'cm':'in',/cm/i.test(options[0])?'cm':'in'];}
// Preserve product-specific HTML tables and extract only exact size matches.
if(!chart&&original){var doc=new DOMParser().parseFromString(original,'text/html'),table=doc.querySelector('table');if(table){var trs=Array.from(table.rows).map(function(r){return Array.from(r.cells).map(function(c){return c.textContent.trim();});});if(trs.length>1&&/size/i.test(trs[0][0])&&trs.slice(1).some(function(r){return options.some(function(o){return normalize(o)===normalize(r[0]);});})){chart=C('Size & Fit',trs[0].slice(1),trs[0].slice(1).map(function(){return '';}),trs.slice(1));}}}

      if(!chart&&!original){original='<p>Contact us for this product’s size and fit details.</p>';}
      var summary=document.createElement('div');summary.className='elfv2-fit-summary';
var uid='elfv2-fit-'+Math.random().toString(36).slice(2),dialog=document.createElement('dialog');dialog.className='elfv2-fit-dialog';dialog.setAttribute('aria-labelledby',uid);dialog.id=uid+'-dialog';
var convertible=chart&&chart.units.every(function(u){return u==='in'||u==='lb'||u==='cm';});
dialog.innerHTML='<div class="elfv2-fit-inner"><header class="elfv2-fit-head"><div><h2 id="'+uid+'">'+esc(chart?chart.name+' Size Guide':'Size & Fit Guide')+'</h2><p>'+esc(chart&&chart.units.indexOf('lb')>=0?'Find their fit using current measurements.':title)+'</p></div><button type="button" class="elfv2-fit-close" aria-label="Close size guide">×</button></header><div class="elfv2-fit-body">'+(convertible?'<div class="elfv2-fit-units" role="group" aria-label="Measurement units"><button type="button" data-unit="imperial" aria-pressed="true">in / lb</button><button type="button" data-unit="metric" aria-pressed="false">cm / kg</button></div>':'')+(chart&&chart.columns.length>2?'<p class="elfv2-fit-swipe">Swipe the table to see all measurements →</p>':'')+'<div class="elfv2-fit-table-wrap"></div><div class="elfv2-fit-help">Need help choosing or between sizes? <a href="/pages/contact-us">Contact us</a> for fit advice.</div>'+'</div></div>';
document.body.appendChild(dialog);var metric=product.fitMetric===undefined?(chart&&chart.units.every(function(u){return u==='cm';})):product.fitMetric,selected=-1;
function unit(i){var u=chart.units[i];return metric?(u==='lb'?'kg':u==='in'?'cm':u):(u==='cm'?'in':u);}
function measure(v,i){var u=chart.units[i],factor=metric?(u==='lb'?.45359237:u==='in'?2.54:1):(u==='cm'?1/2.54:1);if(factor===1)return v;return String(v).replace(/\d+(?:\.\d+)?/g,function(n){return String(Math.round(Number(n)*factor*10)/10);});}
function render(){var value=getSelected();selected=chart?chart.rows.findIndex(function(r){return normalize(r[0])===normalize(value);}):-1;
if(chart){var headers=chart.columns.map(function(h,i){return '<th scope="col">'+esc(h)+(unit(i)?' ('+unit(i)+')':'')+'</th>';}).join('');dialog.querySelector('.elfv2-fit-table-wrap').innerHTML='<table class="elfv2-fit-table" aria-label="'+esc(chart.name+' measurements')+'"><thead><tr><th scope="col">Size</th>'+headers+'</tr></thead><tbody>'+chart.rows.map(function(r,j){return '<tr'+(j===selected?' aria-current="true"':'')+'><th scope="row">'+esc(r[0])+'</th>'+r.slice(1).map(function(v,i){return '<td>'+esc(measure(v,i))+'</td>';}).join('')+'</tr>';}).join('')+'</tbody></table>';
summary.textContent=selected<0?'':value+' · '+chart.rows[selected].slice(1).map(function(v,i){return chart.columns[i]+': '+measure(v,i)+(unit(i)?' '+unit(i):'');}).join(' · ');
if(selected<0&&value)summary.textContent=value+' — see the original guide or contact us for this size’s measurements.';
}else{summary.textContent='';dialog.querySelector('.elfv2-fit-table-wrap').innerHTML='<div class="elfv2-fit-source">'+original+'</div>';var details=dialog.querySelector('.elfv2-fit-original');if(details)details.hidden=true;}
dialog.querySelectorAll('[data-unit]').forEach(function(b){b.setAttribute('aria-pressed',String((b.dataset.unit==='metric')===metric));});}

      const body=dialog.querySelector('.elfv2-fit-body');
      if(preview){const back=document.createElement('button');back.type='button';back.className='elfv2-fit-back';back.textContent='Back to product preview';back.addEventListener('click',()=>dialog.close());body.prepend(back);preview.inert=true;preview.setAttribute('aria-hidden','true');preview.removeAttribute('aria-modal');}
      if(chooser){
        const categories=['Baby','Kids','Men','Women','Dress','Shorts'];
        const category=product.fitCategory||'Baby';
        const currentUnit=metric;
        const categoriesData={Baby:fitProducts.find(p=>/footie/i.test(p.title)),Kids:fitProducts.find(p=>/kids pajamas/i.test(p.title)),Men:fitProducts.find(p=>/men's/i.test(p.title)&&!/women/i.test(p.title)),Women:fitProducts.find(p=>/women/i.test(p.title)),Dress:fitProducts.find(p=>/dress/i.test(p.title))};
        const choose=(name,shortType='Kids')=>{
          let next=categoriesData[name];
          if(name==='Shorts'){const base=categoriesData[shortType];next={...base,title:shortType==='Kids'?'Kids Short Sets':"Women's Short Sets",kind:'Short Set',fitShortType:shortType};}
          next={...next,fitCategory:name,fitMetric:metric};dialog.close();openFit(next,trigger,()=>'',null,true,true);
        };
        const tabs=document.createElement('div');tabs.className='elfv2-fit-tabs';tabs.setAttribute('role','tablist');tabs.setAttribute('aria-label','Size guide style');
        const panel=document.createElement('div');panel.id=uid+'-panel';panel.setAttribute('role','tabpanel');panel.tabIndex=0;
        while(body.firstChild)panel.append(body.firstChild);body.append(tabs,panel);
        categories.forEach((name,i)=>{const button=document.createElement('button');button.type='button';button.id=uid+'-tab-'+i;button.textContent=name;button.setAttribute('role','tab');button.setAttribute('aria-selected',String(name===category));button.setAttribute('aria-controls',panel.id);button.tabIndex=name===category?0:-1;if(name===category)panel.setAttribute('aria-labelledby',button.id);button.addEventListener('click',()=>choose(name));button.addEventListener('keydown',event=>{let n=i;if(event.key==='ArrowRight')n=(i+1)%categories.length;else if(event.key==='ArrowLeft')n=(i+categories.length-1)%categories.length;else if(event.key==='Home')n=0;else if(event.key==='End')n=categories.length-1;else return;event.preventDefault();choose(categories[n]);});tabs.append(button);});
        if(category==='Shorts'){const group=document.createElement('div');group.className='elfv2-fit-short-types';group.setAttribute('role','group');group.setAttribute('aria-label','Short set guide');const note=document.createElement('p');note.textContent='Choose the existing short-set guide for kids or women.';group.append(note);['Kids','Women'].forEach(name=>{const b=document.createElement('button');b.type='button';b.textContent=name==='Kids'?'Kids short sets':"Women's short sets";b.setAttribute('aria-pressed',String((product.fitShortType||'Kids')===name));b.addEventListener('click',()=>choose('Shorts',name));group.append(b);});panel.prepend(group);}
      }
      dialog.addEventListener('close',()=>{if(openFitDialog===dialog)openFitDialog=null;if(preview&&preview.isConnected){preview.inert=false;preview.setAttribute('aria-hidden','false');preview.setAttribute('aria-modal','true');}dialog.remove();if(trigger.isConnected)trigger.focus({preventScroll:true});});
      dialog.querySelector('.elfv2-fit-close').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
      dialog.querySelectorAll('[data-unit]').forEach(b=>b.addEventListener('click',()=>{metric=b.dataset.unit==='metric';render();}));
      dialog.addEventListener('keydown',event=>{if(event.key!=='Tab')return;const stops=[...dialog.querySelectorAll('button:not(:disabled),a[href],select')].filter(e=>e.tabIndex>=0&&e.getClientRects().length);const first=stops[0],last=stops[stops.length-1];if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}});
      render();openFitDialog=dialog;dialog.showModal();(focusTab?dialog.querySelector('[role=tab][aria-selected=true]'):dialog.querySelector('.elfv2-fit-close')).focus();
    }
    root.querySelectorAll('a[href="/pages/size-chart"]').forEach(link=>{link.setAttribute('aria-haspopup','dialog');link.addEventListener('click',event=>{event.preventDefault();openFit(fitProducts[0],link,()=>'',null,true);});});

    // Enhance the existing theme quick-add only when opened from this V2 section.
    let previewTrigger=null, activePreview=null, previewPortal=null, closingUntil=0;
    const setAttr=(el,name,value)=>{if(el.getAttribute(name)!==value)el.setAttribute(name,value);};
    const upgradePreview=()=>{
      if(!previewTrigger||openFitDialog)return;
      const portal=document.getElementById('AddToCartWidgetView');
      if(portal&&portal!==previewPortal){previewPortal=portal;modalObserver.disconnect();modalObserver.observe(portal,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});}
      const modal=portal?.querySelector('.bottom-sheet-modal.visible');
      if(!modal){const closing=portal?.querySelector('.bottom-sheet-modal');if(closing)setAttr(closing,'aria-hidden','true');if(activePreview){activePreview=null;closingUntil=Date.now()+350;if(previewTrigger.isConnected)previewTrigger.focus({preventScroll:true});}return;}
      const firstOpen=activePreview!==modal;activePreview=modal;
      setAttr(modal,'aria-hidden','false');setAttr(modal,'role','dialog');setAttr(modal,'aria-modal','true');setAttr(modal,'aria-label','Product preview');
      const title=modal.querySelector('[data-test="product-title"]');
      if(title){setAttr(title,'id','elfv2-preview-title');setAttr(modal,'aria-labelledby','elfv2-preview-title');}
      const close=modal.querySelector('[data-test="bottom-sheet-modal-close-button"]');
      if(close){setAttr(close,'role','button');setAttr(close,'tabindex','0');setAttr(close,'aria-label','Close product preview');}
      modal.querySelectorAll('.widget-product-option-value').forEach(option=>{
        const unavailable=Number(option.style.opacity)<1;
        setAttr(option,'role','button');setAttr(option,'tabindex',unavailable?'-1':'0');
        setAttr(option,'aria-disabled',String(unavailable));
        setAttr(option,'aria-label',option.textContent.trim()+(unavailable?' — Sold out':''));
        setAttr(option,'aria-pressed',String(option.style.backgroundColor==='var(--text-color)'));
      });
      [['.fd-swiper__button-prev','Previous product photo'],['.fd-swiper__button-next','Next product photo']].forEach(([selector,label])=>{
        const arrow=modal.querySelector(selector);if(!arrow)return;
        setAttr(arrow,'role','button');setAttr(arrow,'tabindex',arrow.classList.contains('disabled')?'-1':'0');setAttr(arrow,'aria-label',label);setAttr(arrow,'aria-disabled',String(arrow.classList.contains('disabled')));
      });
      modal.querySelectorAll('.fd__pagination').forEach((dot,i)=>{setAttr(dot,'aria-label','Product photo '+(i+1));setAttr(dot,'tabindex','-1');setAttr(dot,'aria-current',String(dot.classList.contains('selected')));});
      if(!modal.querySelector('.elfv2-fit-trigger')){
        const guide=document.createElement('button');guide.type='button';guide.className='elfv2-fit-trigger';guide.setAttribute('aria-haspopup','dialog');guide.textContent='Size & fit guide';
        const target=modal.querySelector('.widget-product-option-value');
        if(target){target.parentElement.before(guide);guide.addEventListener('click',()=>{const product=JSON.parse(previewTrigger.closest('.elfv2-product').querySelector('.elfv2-fit-data').textContent);openFit(product,guide,()=>modal.querySelector('.widget-product-option-value[aria-pressed="true"]')?.textContent.trim()||'',modal);});}
      }
      if(firstOpen&&close)close.focus({preventScroll:true});
    };
    root.addEventListener('click',event=>{const trigger=event.target.closest('.elfv2-preview-trigger');if(!trigger)return;
      if(Date.now()<closingUntil){event.preventDefault();event.stopPropagation();setTimeout(()=>{if(trigger.isConnected)trigger.click();},closingUntil-Date.now()+20);return;}
      previewTrigger=trigger;requestAnimationFrame(upgradePreview);
    },true);
    const modalObserver=new MutationObserver(upgradePreview);
    const previewObserver=new MutationObserver(upgradePreview);
    previewObserver.observe(document.body,{childList:true});
    document.addEventListener('keydown',event=>{
      if(openFitDialog||!activePreview||!activePreview.isConnected)return;
      if(event.key==='Escape'){event.preventDefault();event.stopPropagation();activePreview.querySelector('[data-test="bottom-sheet-modal-close-button"]')?.click();return;}
      const current=document.activeElement;
      if((event.key==='Enter'||event.key===' ')&&activePreview.contains(current)&&current.matches('[role="button"]:not(button)')){event.preventDefault();if(current.getAttribute('aria-disabled')!=='true')current.click();return;}
      if(event.key==='Tab'){
        const stops=[...activePreview.querySelectorAll('button:not(:disabled),a[href],[tabindex="0"],input:not(:disabled),select:not(:disabled)')].filter(e=>e.tabIndex>=0&&e.getClientRects().length&&e.getAttribute('aria-disabled')!=='true');
        const first=stops[0],last=stops[stops.length-1];if(!first)return;
        if(event.shiftKey&&(current===first||!activePreview.contains(current))){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&(current===last||!activePreview.contains(current))){event.preventDefault();first.focus();}
      }
    },true);
    const row=root.querySelector('.elfv2-story-grid'), nav=root.querySelector('.elfv2-carousel-nav');
    const arrows=[...nav.querySelectorAll('button')];
    const syncArrows=()=>{const end=row.scrollWidth-row.clientWidth;nav.hidden=end<2;arrows[0].disabled=row.scrollLeft<2;arrows[1].disabled=row.scrollLeft>=end-2;};
    arrows.forEach(button=>button.addEventListener('click',()=>row.scrollBy({left:Number(button.dataset.elfv2Direction)*row.clientWidth,behavior:'auto'})));
    row.addEventListener('scroll',syncArrows,{passive:true});
    const rowResize=new ResizeObserver(syncArrows);rowResize.observe(row);syncArrows();

    const filters = root.querySelector('.elfv2-filters');
    filters.hidden = false;
    const cards = [...root.querySelectorAll('[data-elfv2-group]')];
    function filter(value) {
      cards.forEach(card => card.hidden = value !== 'all' && card.dataset.elfv2Group !== value);
      filters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.elfv2Filter === value)));
    }
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-elfv2-filter]');
      if (button) filter(button.dataset.elfv2Filter);
    });
    root.querySelectorAll('[data-elfv2-shortcut]').forEach(link => link.addEventListener('click', () => filter(link.dataset.elfv2Shortcut)));

  }
  document.querySelectorAll('.bb-elfv2').forEach(init);
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('.bb-elfv2')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellabu-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-benefits-strip')) {
    customElements.define('bb-benefits-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.viewport = this.querySelector('.bb-benefits__viewport');
        this.track = this.querySelector('.bb-benefits__track');
        this.group = this.querySelector('.bb-benefits__group');
        this.toggle = this.querySelector('.bb-benefits__toggle');
        if (!this.viewport || !this.group) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous = this.querySelector('.bb-benefits__previous');
        this.next = this.querySelector('.bb-benefits__next');
        const updateNavigation = () => {
          const max = this.viewport.scrollWidth - this.viewport.clientWidth;
          this.previous.hidden = this.next.hidden = max < 2;
          this.previous.disabled = this.viewport.scrollLeft < 2;
          this.next.disabled = this.viewport.scrollLeft >= max - 2;
        };
        const navigate = direction => {
          this.pause?.();
          this.viewport.scrollBy({left: direction * this.viewport.clientWidth * .8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        this.previous.addEventListener('click', () => navigate(-1), options);
        this.next.addEventListener('click', () => navigate(1), options);
        this.viewport.addEventListener('scroll', updateNavigation, options);
        this.navigationResize = new ResizeObserver(updateNavigation);
        this.navigationResize.observe(this.viewport);
        this.navigationResize.observe(this.group);
        updateNavigation();
        if (this.dataset.autoplay !== 'true') return;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = false;
        // Animate transform on the compositor; native scrolling is retained for interaction.
        this.stopToScroll = () => {
          if (!this.animation) return;
          const elapsed = Number(this.animation.currentTime) || 0;
          const offset = this.duration ? (elapsed % this.duration) / this.duration * this.distance : 0;
          this.animation.cancel();
          this.animation = null;
          this.viewport.scrollLeft += offset;
        };
        this.playback = () => {
          if (this.paused || this.reduced.matches || !this.distance || !this.track.animate) {
            this.stopToScroll();
            return;
          }
          if (!this.animation) {
            const offset = this.viewport.scrollLeft % this.distance;
            const loopSeconds = Number(this.dataset.loopSeconds);
            this.duration = loopSeconds > 0 ? loopSeconds * 1000 : this.distance * 1000 / Number(this.dataset.speed || 24);
            this.viewport.scrollLeft = 0;
            this.animation = this.track.animate(
              [{ transform: 'translate3d(0,0,0)' }, { transform: `translate3d(${-this.distance}px,0,0)` }],
              { duration: this.duration, iterations: Infinity, easing: 'linear' }
            );
            this.animation.currentTime = offset / this.distance * this.duration;
          }
          if (this.hovered || this.focused || !this.visible || document.hidden) this.animation.pause();
          else this.animation.play();
        };
        this.visible = true;
        this.hovered = false;
        this.focused = false;
        this.resize = () => {
          this.stopToScroll();
          const progress = this.distance ? this.viewport.scrollLeft / this.distance : 0;
          this.viewport.scrollLeft = 0;
          this.track.querySelectorAll('[data-bb-copy]').forEach(copy => copy.remove());
          this.distance = this.group.getBoundingClientRect().width + 14;
          if (!this.distance || this.reduced.matches) {
            updateNavigation();
            this.playback();
            return;
          }
          const copies = Math.ceil(this.viewport.clientWidth / this.distance) + 1;
          for (let i = 0; i < copies; i += 1) {
            const copy = this.group.cloneNode(true);
            copy.dataset.bbCopy = 'true';
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(element => element.setAttribute('tabindex', '-1'));
            copy.querySelectorAll('[data-shopify-editor-block]').forEach(card => card.removeAttribute('data-shopify-editor-block'));
            this.track.append(copy);
          }
          this.viewport.scrollLeft = progress * this.distance;
          updateNavigation();
          this.playback();
        };
        this.update = () => {
          this.toggle.hidden = this.reduced.matches;
          this.toggle.setAttribute('aria-pressed', String(this.paused));
          const label = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
          this.toggle.setAttribute('aria-label', label);
          this.toggle.querySelector('span').textContent = label;
          this.playback();
        };
        this.pause = () => { this.paused = true; this.update(); };
        this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.update(); }, options);
        this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.playback(); } }, options);
        this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.playback(); }, options);
        this.viewport.addEventListener('pointerdown', this.pause, options);
        this.viewport.addEventListener('wheel', this.pause, { ...options, passive: true });
        this.viewport.addEventListener('keydown', this.pause, options);
        this.viewport.addEventListener('focusin', () => { this.focused = true; this.stopToScroll(); this.playback(); }, options);
        this.viewport.addEventListener('focusout', () => { this.focused = false; this.playback(); }, options);
        this.reduced.addEventListener('change', () => { this.resize(); this.update(); }, options);
        this.addEventListener('shopify:block:select', this.pause, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.playback(); });
        this.observer.observe(this);
        this.resizer = new ResizeObserver(this.resize);
        this.resizer.observe(this.viewport);
        this.resizer.observe(this.group);
        this.resize();
        this.update();
        document.addEventListener('visibilitychange', () => this.playback(), options);
      }
      disconnectedCallback() {
        this.animation?.cancel();
        this.animation = null;
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizer?.disconnect();
        this.navigationResize?.disconnect();
        this.track?.querySelectorAll('[data-bb-copy]').forEach(copy => copy.remove());
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-rewards-page-hero"] && !Shopify.designMode) return;
  try {
    
  const placeholderBR = document.querySelector(".gw-widget-placeholder-BR");
  if (placeholderBR && (location.pathname.includes("rewards") || location.pathname.includes("loyalty"))){
    placeholderBR.style.display = "none";
  }

  } catch(e) { console.error(e); }
})();
})();
